// // TopToolbarNew.jsx - Complete component for new flow (JV/JD and BUILD TO SUIT)
// import { useState, useMemo, useEffect, useRef } from 'react';
// import {
//   AppBar, Toolbar, Box, Chip, Paper, List, ListItem, ListItemText,
//   CircularProgress, IconButton, InputBase, Typography,
//   Menu, Divider, Slider, Button
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import TuneIcon from '@mui/icons-material/Tune';
// import { useNavigate } from 'react-router-dom'; 
// import useLocationSearch from './useLocationSearch';

// const PRICE_MIN = 0;
// const PRICE_MAX = 100000000000;
// const PRIMARY_BROWN = '#6B3620'; // Your requested color
// const PRIMARY_BROWN_HOVER = '#4A2315'; // Darker shade for hover

// // Price ranges
// const purchaseRanges = [
//   { label: '5L - 10L', min: 500000, max: 1000000 },
//   { label: '10L - 20L', min: 1000000, max: 2000000 },
//   { label: '20L - 30L', min: 2000000, max: 3000000 },
//   { label: '30L - 40L', min: 3000000, max: 4000000 },
//   { label: '40L - 50L', min: 4000000, max: 5000000 },
//   { label: '50L - 60L', min: 5000000, max: 6000000 },
//   { label: '60L - 70L', min: 6000000, max: 7000000 },
//   { label: '70L - 80L', min: 7000000, max: 8000000 },
//   { label: '80L - 90L', min: 8000000, max: 9000000 },
//   { label: '90L - 1CR', min: 9000000, max: 10000000 },
//   { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
//   { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
//   { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
//   { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
//   { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
//   { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
//   { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
//   { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
//   { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
//   { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
//   { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
//   { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
//   { label: '6CR - 8CR', min: 60000000, max: 80000000 },
//   { label: '8CR - 9CR', min: 80000000, max: 90000000 },
//   { label: '9CR - 10CR', min: 90000000, max: 100000000 },
//   { label: '10CR - 15CR', min: 100000000, max: 150000000 },
//   { label: '15CR - 20CR', min: 150000000, max: 200000000 },
//   { label: '20CR - 25CR', min: 200000000, max: 250000000 },
//   { label: '25CR - 30CR', min: 250000000, max: 300000000 },
//   { label: '30CR - 40CR', min: 300000000, max: 400000000 },
//   { label: '40CR - 50CR', min: 400000000, max: 500000000 },
//   { label: '50CR - 60CR', min: 500000000, max: 600000000 },
//   { label: '60CR - 70CR', min: 600000000, max: 700000000 },
//   { label: '70CR - 80CR', min: 700000000, max: 800000000 },
//   { label: '80CR - 90CR', min: 800000000, max: 900000000 },
//   { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
//   { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
//   { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
//   { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
//   { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
//   { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
//   { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
//   { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
//   { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
//   { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
//   { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
//   { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
//   { label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
//   { label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
//   { label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
//   { label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
//   { label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
//   { label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
//   { label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
//   { label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
//   { label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },
//   { label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
//   { label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
//   { label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
//   { label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
//   { label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
//   { label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
//   { label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
//   { label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
//   { label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
//   { label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },
//   { label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 }
// ];

// const formatPrice = (value) => {
//   if (value === 0) return 'No Min';
//   if (value >= 10000000) return `${(value / 10000000).toFixed(1)} Cr`;
//   if (value >= 100000) return `${(value / 100000).toFixed(1)} L`;
//   if (value >= 1000) return `${(value / 1000).toFixed(1)} K`;
//   return value;
// };

// export default function TopToolbarNew({
//   typeOptions = [],
//   propertyTypeOptions = [],
//   selectedTypes = [],
//   onTypesChange,
//   selectedPropertyTypes = [],
//   onPropertyTypesChange,
//   priceRange,
//   onPriceRangeChange,
//   onLocationSelect,
//   onClearLocation,
// }) {
//   const navigate = useNavigate();
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showResults, setShowResults] = useState(false);
//   const { results, loading } = useLocationSearch(searchTerm);
//   const searchRef = useRef(null);

//   // Price filter state
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [tempSelectedRange, setTempSelectedRange] = useState(null);
//   const [customRange, setCustomRange] = useState(priceRange || [PRICE_MIN, PRICE_MAX]);
//   const [sliderMax, setSliderMax] = useState(PRICE_MAX);

//   // Sync customRange with priceRange prop
//   useEffect(() => {
//     if (priceRange) {
//       setCustomRange(priceRange);
//     }
//   }, [priceRange]);

//   const handlePlaceSelected = (locationData) => {
//     setSelectedLocation(locationData);
//     setSearchTerm('');
//     setShowResults(false);
//     if (onLocationSelect) {
//       onLocationSelect({
//         lat: locationData.lat,
//         lng: locationData.lng,
//         name: locationData.label,
//         address: locationData.label
//       });
//     }
//   };

//   const handleClearLocation = () => {
//     setSelectedLocation(null);
//     setSearchTerm('');
//     setShowResults(false);
//     if (onClearLocation) onClearLocation();
//   };

//   const handleTypeClick = (type) => {
//     if (selectedTypes.includes(type)) {
//       onTypesChange(selectedTypes.filter(t => t !== type));
//     } else {
//       onTypesChange([...selectedTypes, type]);
//     }
//   };

//   const handlePropertyTypeClick = (propertyType) => {
//     if (selectedPropertyTypes.includes(propertyType)) {
//       onPropertyTypesChange(selectedPropertyTypes.filter(p => p !== propertyType));
//     } else {
//       onPropertyTypesChange([...selectedPropertyTypes, propertyType]);
//     }
//   };

//   // Price filter handlers
//   const handleTuneClick = (event) => setAnchorEl(event.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);

//   const handleRangeButtonSelect = (range) => {
//     setCustomRange([range.min, range.max]);
//     setTempSelectedRange({
//       label: range.label,
//       min: range.min,
//       max: range.max,
//     });
//     setSliderMax(range.max > sliderMax ? range.max : sliderMax);
//   };

//   const handleSliderChangeTemp = (e, newValue) => {
//     setCustomRange(newValue);
//     setTempSelectedRange({
//       label: `${formatPrice(newValue[0])} - ${formatPrice(newValue[1])}`,
//       min: newValue[0],
//       max: newValue[1],
//     });
//     if (newValue[1] > sliderMax) setSliderMax(newValue[1]);
//   };

//   const handleApplyFilter = () => {
//     if (onPriceRangeChange) {
//       onPriceRangeChange([customRange[0], customRange[1]]);
//     }
//     setTempSelectedRange(null);
//     handleMenuClose();
//   };

//   const clearPriceFilter = () => {
//     setCustomRange([PRICE_MIN, PRICE_MAX]);
//     setTempSelectedRange(null);
//     if (onPriceRangeChange) {
//       onPriceRangeChange([PRICE_MIN, PRICE_MAX]);
//     }
//     handleMenuClose();
//   };

//   // Click outside to close results
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setShowResults(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   return (
//     <AppBar position="fixed" elevation={0} sx={{
//       bgcolor: '#F6F0E6', // Updated background color
//       color: '#222',
//       backdropFilter: 'blur(10px)',
//       zIndex: 1200,
//     }}>
//     <Toolbar
//   sx={{
//     display: 'flex',
//     flexDirection: 'column',      // ✅ stack everything vertically
//     alignItems: 'stretch',
//     gap: 0.5,
//     py: 0.5,
//   }}
// >
//   {/* ─── ROW 1: Search box ───────────────────────────────────────────── */}
//   <Box sx={{ position: 'relative' }} ref={searchRef}>
//     <Paper
//       component="form"
//       elevation={0}
//       sx={{
//         display: 'flex', alignItems: 'center',
//         height: 32,
//         borderRadius: '30px',
//         px: 0.8,
//         backgroundColor: '#f2f5f7',
//         border: '1px solid black',
//       }}
//       onSubmit={(e) => e.preventDefault()}
//     >
//       <IconButton
//         onClick={() => navigate(-1)}
//         size="small"
//         sx={{ color: 'black', p: 0.5 }}
//       >
//         <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
//       </IconButton>

//       <InputBase
//         sx={{ ml: 1, flex: 1, fontSize: '13.5px' }}
//         placeholder={selectedLocation ? selectedLocation.label : "Search location..."}
//         value={searchTerm}
//         onChange={(e) => {
//           setSearchTerm(e.target.value);
//           setShowResults(true);
//         }}
//         onFocus={() => setShowResults(true)}
//       />

//       {(searchTerm || selectedLocation) && (
//         <IconButton
//           onClick={handleClearLocation}
//           size="small"
//           sx={{ color: 'black', p: 0.5 }}
//         >
//           <ClearIcon sx={{ fontSize: 18 }} />
//         </IconButton>
//       )}

//       <IconButton type="submit" size="small" sx={{ color: 'black', p: 0.5 }}>
//         <SearchIcon sx={{ fontSize: 18 }} />
//       </IconButton>

//       <IconButton size="small" sx={{ color: 'black', p: 0.5 }} onClick={handleTuneClick}>
//         <TuneIcon sx={{ fontSize: 18 }} />
//       </IconButton>
//     </Paper>

//     {/* Search Results Dropdown */}
//     {showResults && searchTerm.length >= 3 && (
//       <Paper
//         elevation={6}
//         sx={{
//           position: 'absolute',
//           top: '100%',
//           left: 0,
//           right: 0,
//           zIndex: 1300,
//           mt: 0.5,
//           borderRadius: '12px',
//           overflow: 'hidden',
//           maxHeight: 300,
//           overflowY: 'auto',
//         }}
//       >
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//             <CircularProgress size={24} />
//           </Box>
//         ) : results.length > 0 ? (
//           <List dense sx={{ py: 0 }}>
//             {results.map((result, idx) => (
//               <ListItem
//                 key={idx}
//                 onClick={() => handlePlaceSelected(result)}
//                 sx={{
//                   cursor: 'pointer',
//                   py: 0.4, px: 1.5, minHeight: 'auto',
//                   alignItems: 'center',
//                   '&:hover': { bgcolor: 'action.hover' },
//                 }}
//               >
//                 <LocationOnIcon sx={{ mr: 1, color: 'primary.main', fontSize: 14, flexShrink: 0 }} />
//                 <ListItemText
//                   primary={result.label}
//                   primaryTypographyProps={{
//                     fontSize: '13px',
//                     lineHeight: 1.2,
//                     display: '-webkit-box',
//                     WebkitLineClamp: 2,
//                     WebkitBoxOrient: 'vertical',
//                     overflow: 'hidden',
//                   }}
//                   sx={{ my: 0 }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         ) : (
//           <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
//             <Typography variant="body2">No locations found</Typography>
//           </Box>
//         )}
//       </Paper>
//     )}
//   </Box>

// <Box
//   sx={{
//     display: 'flex',
//     justifyContent: 'space-between',      // ✅ first chip left, last chip right
//     alignItems: 'center',
//     gap: 0.6,
//     overflowX: 'auto',
//     flexWrap: 'nowrap',
//     width: '100%',
//     '&::-webkit-scrollbar': { display: 'none' },
//     scrollbarWidth: 'none',
//     msOverflowStyle: 'none',
//   }}
// >
//   {typeOptions.map((item, i) => {
//     const type = typeof item === 'string' ? item : item.value;
//     const isActive = selectedTypes.includes(type);
//     return (
//       <Chip
//         key={i}
//         label={type}
//         onClick={() => handleTypeClick(type)}
//         sx={{
//           flexShrink: 0,
//           height: 22,
//           borderRadius: '20px',
//           fontWeight: 'bold',
//           fontSize: '12px',
//           bgcolor: isActive ? '#000' : 'transparent',
//           color: isActive ? '#fff' : '#000',
//           border: '1px solid black',
//           transition: 'all 0.2s ease',
//           '&:hover': {
//             bgcolor: isActive ? '#333' : '#e0e0e0',
//             transform: 'scale(1.02)',
//           },
//           '& .MuiChip-label': {
//             paddingLeft: '8px',
//             paddingRight: '8px',
//             lineHeight: 1,
//           },
//         }}
//       />
//     );
//   })}
// </Box>

//   {/* ─── ROW 3: Sub categories (Land, Layouts) ──────────────────────── */}
//   <Box
//     sx={{
//       display: 'flex',
//       gap: 0.6,
//       overflowX: 'auto',
//       flexWrap: 'nowrap',
//       width: '100%',
//       '&::-webkit-scrollbar': { display: 'none' },
//       scrollbarWidth: 'none',
//       msOverflowStyle: 'none',
//     }}
//   >
// {propertyTypeOptions.map((item, i) => {
//   const propertyType = typeof item === 'string' ? item : item.value;
//   const isActive = selectedPropertyTypes.includes(propertyType);
//   return (
//     <Chip
//       key={i}
//       label={propertyType}
//       onClick={() => handlePropertyTypeClick(propertyType)}
//       sx={{
//         flexShrink: 0,
//         height: 22,
//         borderRadius: '20px',
//         fontWeight: 'bold',
//         fontSize: '12px',
//         // ✅ same as buy page
//         bgcolor: isActive ? '#000' : 'transparent',
//         color: isActive ? '#fff' : '#000',
//         border: '1px solid black',
//         transition: 'all 0.2s ease',
//         '&:hover': {
//           bgcolor: isActive ? '#333' : '#e0e0e0',
//           transform: 'scale(1.02)',
//         },
//         '& .MuiChip-label': {
//           paddingLeft: '8px',
//           paddingRight: '8px',
//           lineHeight: 1,
//         },
//       }}
//     />
//   );
// })}
//   </Box>
// </Toolbar>

//       {/* Price Filter Menu */}
//       <Menu
//         id="filter-menu"
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         PaperProps={{
//           style: {
//             width: '380px',
//             maxHeight: '540px',
//             padding: '8px 0'
//           }
//         }}
//       >
//         <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
//           Select Price Range
//         </Typography>
//         <Divider />

//         <Box sx={{ px: 2, py: 2 }}>
//           <Slider
//             value={customRange}
//             onChange={handleSliderChangeTemp}
//             min={PRICE_MIN}
//             max={sliderMax}
//             step={1000}
//             valueLabelDisplay="auto"
//             valueLabelFormat={(value) => formatPrice(value)}
//             sx={{
//               color: PRIMARY_BROWN,
//               '& .MuiSlider-thumb': {
//                 backgroundColor: PRIMARY_BROWN,
//               },
//               '& .MuiSlider-track': {
//                 backgroundColor: PRIMARY_BROWN,
//               },
//               '& .MuiSlider-rail': {
//                 backgroundColor: '#d1d1d1',
//               }
//             }}
//           />
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//             <Typography variant="caption">{formatPrice(customRange[0])}</Typography>
//             <Typography variant="caption">{formatPrice(customRange[1])}</Typography>
//           </Box>
//         </Box>

//         <Divider />

//         <Box sx={{ px: 2, py: 2 }}>
//           <Box sx={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(3, 1fr)',
//             gap: 1,
//             maxHeight: '300px',
//             overflowY: 'auto'
//           }}>
//             {purchaseRanges.map((range, index) => {
//               const isRangeActive = customRange[0] === range.min && customRange[1] === range.max;
//               return (
//                 <Button
//                   key={range.label}
//                   variant={isRangeActive ? 'contained' : 'outlined'}
//                   size="small"
//                   sx={{
//                     borderRadius: '16px',
//                     textTransform: 'none',
//                     fontSize: '0.6rem',
//                     minWidth: 'auto',
//                     px: 1,
//                     py: 0.5,
//                     width: '90px',
//                     whiteSpace: 'nowrap',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                     // Brown theme
//                     backgroundColor: isRangeActive ? PRIMARY_BROWN : 'transparent',
//                     color: isRangeActive ? '#fff' : PRIMARY_BROWN,
//                     borderColor: PRIMARY_BROWN,
//                     '&:hover': {
//                       backgroundColor: isRangeActive ? PRIMARY_BROWN_HOVER : 'rgba(107, 54, 32, 0.08)',
//                       borderColor: PRIMARY_BROWN_HOVER,
//                     },
//                     ...(index === purchaseRanges.length - 1 && {
//                       width: '100%',
//                       gridColumn: 'span 3',
//                     }),
//                   }}
//                   onClick={() => handleRangeButtonSelect(range)}
//                 >
//                   {range.label}
//                 </Button>
//               );
//             })}
//           </Box>
//         </Box>

//         <Divider />

//         <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
//           <Button 
//             onClick={clearPriceFilter} 
//             sx={{ 
//               color: PRIMARY_BROWN, 
//               fontWeight: 'bold',
//               '&:hover': { backgroundColor: 'rgba(107, 54, 32, 0.08)' }
//             }}
//           >
//             CLEAR
//           </Button>
//           <Button 
//             onClick={handleApplyFilter} 
//             variant="contained" 
//             sx={{ 
//               backgroundColor: PRIMARY_BROWN, 
//               fontWeight: 'bold',
//               '&:hover': { backgroundColor: PRIMARY_BROWN_HOVER }
//             }}
//           >
//             APPLY
//           </Button>
//         </Box>
//       </Menu>
//     </AppBar>
//   );
// }



// TopToolbarNew.jsx - Complete component for new flow (JV/JD and BUILD TO SUIT)
import { useState, useEffect, useRef } from 'react';
import {
  AppBar, Toolbar, Box, Chip, Paper, List, ListItem, ListItemText,
  CircularProgress, IconButton, InputBase, Typography,
  Menu, Divider, Slider, Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TuneIcon from '@mui/icons-material/Tune';

// ✅ Category Icons
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessIcon from '@mui/icons-material/Business';
import LandscapeIcon from '@mui/icons-material/Landscape';
import VillaIcon from '@mui/icons-material/Villa';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SellIcon from '@mui/icons-material/Sell';
import HomeIcon from '@mui/icons-material/Home';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ConstructionIcon from '@mui/icons-material/Construction';
import FoundationIcon from '@mui/icons-material/Foundation';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';

import { useNavigate } from 'react-router-dom';
import useLocationSearch from './useLocationSearch';

const PRICE_MIN = 0;
const PRICE_MAX = 100000000000;
const PRIMARY_BROWN = '#6B3620';
const PRIMARY_BROWN_HOVER = '#4A2315';

// ✅ Icon colors for chips
const ICON_BROWN = '#8b4f16';
const ICON_WHITE = '#ffffff';

const purchaseRanges = [
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 20L', min: 1000000, max: 2000000 },
  { label: '20L - 30L', min: 2000000, max: 3000000 },
  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },
  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
  { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
  { label: '6CR - 8CR', min: 60000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
  { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
  { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
  { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
  { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
  { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
  { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
  { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
  { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
  { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
  { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
  { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
  { label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
  { label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
  { label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
  { label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
  { label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
  { label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
  { label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
  { label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
  { label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },
  { label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
  { label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
  { label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
  { label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
  { label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
  { label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
  { label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
  { label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
  { label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
  { label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },
  { label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 }
];

const formatPrice = (value) => {
  if (value === 0) return 'No Min';
  if (value >= 10000000) return `${(value / 10000000).toFixed(1)} Cr`;
  if (value >= 100000) return `${(value / 100000).toFixed(1)} L`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)} K`;
  return value;
};

// ============================================================
// ✅ ICON for TYPE row (build to suit / jv/jd)
// — no color arg; color applied via sx
// ============================================================
const getTypeIcon = (typeName) => {
  const n = (typeName || '').toLowerCase().trim();
  const iconProps = { sx: { fontSize: 16 } };

  if (n.includes('build to suit') || n.includes('bts')) {
    return <ConstructionIcon {...iconProps} />;
  }
  if (n.includes('jv') || n.includes('jd') || n.includes('joint')) {
    return <HandshakeIcon {...iconProps} />;
  }
  return <SellIcon {...iconProps} />;
};

// ============================================================
// ✅ ICON for PROPERTY TYPE row (Land, Plot, Villa, ...)
// — no color arg; color applied via sx
// ============================================================
const getCategoryIcon = (categoryName) => {
  const name = (categoryName || '').toLowerCase().trim();
  const iconProps = { sx: { fontSize: 16 } };

  if (name.includes('commercial land') || name.includes('commercial plot')) {
    return <LandscapeIcon {...iconProps} />;
  }
  if (name.includes('commercial building') || name.includes('commercial')) {
    return <BusinessIcon {...iconProps} />;
  }
  if (name.includes('mixed')) {
    return <BusinessIcon {...iconProps} />;
  }
  if (name.includes('apartment')) {
    return <ApartmentIcon {...iconProps} />;
  }
  if (name.includes('duplex') || name.includes('villa')) {
    return <VillaIcon {...iconProps} />;
  }
  if (name.includes('pg') || name.includes('office')) {
    return <StorefrontIcon {...iconProps} />;
  }
  if (name.includes('plot') || name.includes('land')) {
    return <LandscapeIcon {...iconProps} />;
  }
  if (name.includes('layout')) {
    return <FoundationIcon {...iconProps} />;
  }
  if (name.includes('flat')) {
    return <HomeWorkIcon {...iconProps} />;
  }
  if (name.includes('rental')) {
    return <HomeWorkIcon {...iconProps} />;
  }
  if (name.includes('house')) {
    return <HomeIcon {...iconProps} />;
  }
  if (name.includes('sell')) {
    return <SellIcon {...iconProps} />;
  }

  return <HolidayVillageIcon {...iconProps} />;
};

// ============================================================
// ✅ Shared chip sx — EXACTLY as you pasted
// ============================================================
const getChipSx = (isActive) => ({
  flexShrink: 0,
  height: 38,
  borderRadius: '8px',
  fontWeight: 600,
  fontSize: '12px',
  bgcolor: isActive ? PRIMARY_BROWN : 'transparent',
  color: isActive ? '#fff' : '#1a1a1a',
  border: '1px solid',
  borderColor: isActive ? PRIMARY_BROWN : '#d5d5d5',
  '&:hover': {
    bgcolor: isActive ? PRIMARY_BROWN_HOVER : 'rgba(139,79,22,0.06)',
    borderColor: isActive ? PRIMARY_BROWN_HOVER : ICON_BROWN,
  },
  '& .MuiChip-icon': {
    marginLeft: '8px',
    marginRight: '-4px',
    alignSelf: 'center',
    color: isActive ? '#ffffff !important' : '#8b4f16 !important',
  },
  '& .MuiChip-icon path': {
    fill: isActive ? '#ffffff !important' : '#8b4f16 !important',
  },
  '& .MuiChip-label': {
    paddingLeft: '8px',
    paddingRight: '12px',
    lineHeight: 1.15,
  },
});

export default function TopToolbarNew({
  typeOptions = [],
  propertyTypeOptions = [],
  selectedTypes = [],
  onTypesChange,
  selectedPropertyTypes = [],
  onPropertyTypesChange,
  priceRange,
  onPriceRangeChange,
  onLocationSelect,
  onClearLocation,
}) {
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showResults, setShowResults] = useState(false);
  const { results, loading } = useLocationSearch(searchTerm);
  const searchRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [tempSelectedRange, setTempSelectedRange] = useState(null);
  const [customRange, setCustomRange] = useState(priceRange || [PRICE_MIN, PRICE_MAX]);
  const [sliderMax, setSliderMax] = useState(PRICE_MAX);

  useEffect(() => {
    if (priceRange) setCustomRange(priceRange);
  }, [priceRange]);

  const handlePlaceSelected = (locationData) => {
    setSelectedLocation(locationData);
    setSearchTerm('');
    setShowResults(false);
    if (onLocationSelect) {
      onLocationSelect({
        lat: locationData.lat,
        lng: locationData.lng,
        name: locationData.label,
        address: locationData.label
      });
    }
  };

  const handleClearLocation = () => {
    setSelectedLocation(null);
    setSearchTerm('');
    setShowResults(false);
    if (onClearLocation) onClearLocation();
  };

  const handleTypeClick = (type) => {
    if (selectedTypes.includes(type)) {
      onTypesChange(selectedTypes.filter(t => t !== type));
    } else {
      onTypesChange([...selectedTypes, type]);
    }
  };

  const handlePropertyTypeClick = (propertyType) => {
    if (selectedPropertyTypes.includes(propertyType)) {
      onPropertyTypesChange(selectedPropertyTypes.filter(p => p !== propertyType));
    } else {
      onPropertyTypesChange([...selectedPropertyTypes, propertyType]);
    }
  };

  const handleTuneClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleRangeButtonSelect = (range) => {
    setCustomRange([range.min, range.max]);
    setTempSelectedRange({ label: range.label, min: range.min, max: range.max });
    setSliderMax(range.max > sliderMax ? range.max : sliderMax);
  };

  const handleSliderChangeTemp = (e, newValue) => {
    setCustomRange(newValue);
    setTempSelectedRange({
      label: `${formatPrice(newValue[0])} - ${formatPrice(newValue[1])}`,
      min: newValue[0],
      max: newValue[1],
    });
    if (newValue[1] > sliderMax) setSliderMax(newValue[1]);
  };

  const handleApplyFilter = () => {
    if (onPriceRangeChange) onPriceRangeChange([customRange[0], customRange[1]]);
    setTempSelectedRange(null);
    handleMenuClose();
  };

  const clearPriceFilter = () => {
    setCustomRange([PRICE_MIN, PRICE_MAX]);
    setTempSelectedRange(null);
    if (onPriceRangeChange) onPriceRangeChange([PRICE_MIN, PRICE_MAX]);
    handleMenuClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <AppBar position="fixed" elevation={0} sx={{
      bgcolor: '#F6F0E6',
      color: '#222',
      backdropFilter: 'blur(10px)',
      zIndex: 1200,
    }}>
      <Toolbar
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 0.5,
          py: 0.5,
        }}
      >
        {/* ─── ROW 1: Search box ─────────────────────────────── */}
        <Box sx={{ position: 'relative' }} ref={searchRef}>
          <Paper
            component="form"
            elevation={0}
            sx={{
              display: 'flex', alignItems: 'center',
              height: 32,
              borderRadius: '30px',
              px: 0.8,
              backgroundColor: '#f2f5f7',
              border: '1px solid black',
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <IconButton onClick={() => navigate(-1)} size="small" sx={{ color: 'black', p: 0.5 }}>
              <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
            </IconButton>

            <InputBase
              sx={{ ml: 1, flex: 1, fontSize: '13.5px' }}
              placeholder={selectedLocation ? selectedLocation.label : "Search location..."}
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setShowResults(true); }}
              onFocus={() => setShowResults(true)}
            />

            {(searchTerm || selectedLocation) && (
              <IconButton onClick={handleClearLocation} size="small" sx={{ color: 'black', p: 0.5 }}>
                <ClearIcon sx={{ fontSize: 18 }} />
              </IconButton>
            )}

            <IconButton type="submit" size="small" sx={{ color: 'black', p: 0.5 }}>
              <SearchIcon sx={{ fontSize: 18 }} />
            </IconButton>

            <IconButton size="small" sx={{ color: 'black', p: 0.5 }} onClick={handleTuneClick}>
              <TuneIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Paper>

          {showResults && searchTerm.length >= 3 && (
            <Paper
              elevation={6}
              sx={{
                position: 'absolute', top: '100%', left: 0, right: 0,
                zIndex: 1300, mt: 0.5, borderRadius: '12px',
                overflow: 'hidden', maxHeight: 300, overflowY: 'auto',
              }}
            >
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                  <CircularProgress size={24} />
                </Box>
              ) : results.length > 0 ? (
                <List dense sx={{ py: 0 }}>
                  {results.map((result, idx) => (
                    <ListItem
                      key={idx}
                      onClick={() => handlePlaceSelected(result)}
                      sx={{
                        cursor: 'pointer',
                        py: 0.4, px: 1.5, minHeight: 'auto',
                        alignItems: 'center',
                        '&:hover': { bgcolor: 'action.hover' },
                      }}
                    >
                      <LocationOnIcon sx={{ mr: 1, color: 'primary.main', fontSize: 14, flexShrink: 0 }} />
                      <ListItemText
                        primary={result.label}
                        primaryTypographyProps={{
                          fontSize: '13px', lineHeight: 1.2,
                          display: '-webkit-box', WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical', overflow: 'hidden',
                        }}
                        sx={{ my: 0 }}
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                  <Typography variant="body2">No locations found</Typography>
                </Box>
              )}
            </Paper>
          )}
        </Box>

        {/* ─── ROW 2: Type chips (build to suit / jv/jd) ─────── */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 0.6,
            overflowX: 'auto',
            flexWrap: 'nowrap',
            width: '100%',
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {typeOptions.map((item, i) => {
            const type = typeof item === 'string' ? item : item.value;
            const isActive = selectedTypes.includes(type);

            return (
              <Chip
                key={i}
                icon={getTypeIcon(type)}
                label={type}
                onClick={() => handleTypeClick(type)}
                sx={getChipSx(isActive)}
              />
            );
          })}
        </Box>

        {/* ─── ROW 3: Property type chips (Land, Plot, Villa, ...) ─── */}
        <Box
          sx={{
            display: 'flex',
            gap: 0.6,
            overflowX: 'auto',
            flexWrap: 'nowrap',
            width: '100%',
            '&::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {propertyTypeOptions.map((item, i) => {
            const propertyType = typeof item === 'string' ? item : item.value;
            const isActive = selectedPropertyTypes.includes(propertyType);

            return (
              <Chip
                key={i}
                icon={getCategoryIcon(propertyType)}
                label={propertyType}
                onClick={() => handlePropertyTypeClick(propertyType)}
                sx={getChipSx(isActive)}
              />
            );
          })}
        </Box>
      </Toolbar>

      {/* ─── Price Filter Menu (untouched) ─── */}
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: { width: '380px', maxHeight: '540px', padding: '8px 0' }
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
          Select Price Range
        </Typography>
        <Divider />

        <Box sx={{ px: 2, py: 2 }}>
          <Slider
            value={customRange}
            onChange={handleSliderChangeTemp}
            min={PRICE_MIN}
            max={sliderMax}
            step={1000}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => formatPrice(value)}
            sx={{
              color: PRIMARY_BROWN,
              '& .MuiSlider-thumb': { backgroundColor: PRIMARY_BROWN },
              '& .MuiSlider-track': { backgroundColor: PRIMARY_BROWN },
              '& .MuiSlider-rail': { backgroundColor: '#d1d1d1' }
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <Typography variant="caption">{formatPrice(customRange[0])}</Typography>
            <Typography variant="caption">{formatPrice(customRange[1])}</Typography>
          </Box>
        </Box>

        <Divider />

        <Box sx={{ px: 2, py: 2 }}>
          <Box sx={{
            display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1,
            maxHeight: '300px', overflowY: 'auto'
          }}>
            {purchaseRanges.map((range, index) => {
              const isRangeActive = customRange[0] === range.min && customRange[1] === range.max;
              return (
                <Button
                  key={range.label}
                  variant={isRangeActive ? 'contained' : 'outlined'}
                  size="small"
                  sx={{
                    borderRadius: '16px', textTransform: 'none', fontSize: '0.6rem',
                    minWidth: 'auto', px: 1, py: 0.5, width: '90px',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    backgroundColor: isRangeActive ? PRIMARY_BROWN : 'transparent',
                    color: isRangeActive ? '#fff' : PRIMARY_BROWN,
                    borderColor: PRIMARY_BROWN,
                    '&:hover': {
                      backgroundColor: isRangeActive ? PRIMARY_BROWN_HOVER : 'rgba(107, 54, 32, 0.08)',
                      borderColor: PRIMARY_BROWN_HOVER,
                    },
                    ...(index === purchaseRanges.length - 1 && {
                      width: '100%',
                      gridColumn: 'span 3',
                    }),
                  }}
                  onClick={() => handleRangeButtonSelect(range)}
                >
                  {range.label}
                </Button>
              );
            })}
          </Box>
        </Box>

        <Divider />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, py: 1 }}>
          <Button
            onClick={clearPriceFilter}
            sx={{
              color: PRIMARY_BROWN, fontWeight: 'bold',
              '&:hover': { backgroundColor: 'rgba(107, 54, 32, 0.08)' }
            }}
          >
            CLEAR
          </Button>
          <Button
            onClick={handleApplyFilter}
            variant="contained"
            sx={{
              backgroundColor: PRIMARY_BROWN, fontWeight: 'bold',
              '&:hover': { backgroundColor: PRIMARY_BROWN_HOVER }
            }}
          >
            APPLY
          </Button>
        </Box>
      </Menu>
    </AppBar>
  );
}